import { PoliciesSVG } from 'src/components/Icons/Basic'
import { LinkIcon } from 'src/components/Icons/FileType'
import palette from 'src/designSystem/variables/palette'
import styled, { css } from 'styled-components/macro'

export const SourceSummary = styled.div<{
  $isItalic?: boolean
  $isExplanation?: boolean
}>`
  margin-left: 24px;
  ${({ $isItalic }) => $isItalic && `font-style: italic;`}
  ${({ $isExplanation }) =>
    $isExplanation &&
    `
  color: ${palette.neutral[200]};
  `}
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const SourceContainer = styled.div<{ $isAgentChat?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  line-height: 150%;
  margin-bottom: 8px;
  ${({ $isAgentChat }) =>
    $isAgentChat &&
    css`
      gap: 12px;
      border-radius: 18px;
      text-overflow: ellipsis;
      background-color: ${palette.neutral[50]};
      padding: 8px 12px;
      font-size: 12px;
    `}
`
export const SourceDeleted = styled.span`
  color: ${palette.orange[900]};
  font-style: italic;
`

export const DocumentSourceRelevantDate = styled.span<{
  $isAgentChat?: boolean
}>`
  color: ${({ $isAgentChat }) =>
    $isAgentChat ? palette.neutral[600] : palette.neutral[200]};
`

export const DocumentSourcePolicyIcon = styled(PoliciesSVG)`
  width: 21px;
  height: 21px;
  path {
    fill: ${palette.neutral[200]};
  }
`

export const DocumentSourceLinkIcon = styled(LinkIcon)`
  flex-shrink: 0;
  path {
    fill: ${palette.neutral[600]};
  }
  &:hover {
    cursor: pointer;
    path {
      fill: ${palette.neutral[500]};
    }
  }
`
